require('./react/src/publishers');